export const SEGMENT_KEY = import.meta.env.VITE_SEGMENT_WRITE_KEY;
